import numeral from 'numeral';

const formThousandsSeparator = (val) => {
  if (val) {
    return numeral(val).format('0,0');
  }
  return '';
};

export default formThousandsSeparator;
